const getTariffData = (state) => {
  const allInOne = state?.home?.allInOne;
  const tariffName = allInOne?.serverData?.mobileTariffName;
  const tariffDescription = allInOne?.serverData?.mobileTariffDescription;
  const soc = allInOne?.serverData?.soc;
  const tariffValue = allInOne?.serverData?.feePerMonth;
  const tariffUnit = allInOne?.serverData?.feePerMonthText;
  const mobileTariffUrl = allInOne?.serverData?.mobileTariffUrl;
  const hasDiscount = allInOne?.serverData?.hasDiscount;

  return {
    tariffName,
    tariffValue,
    tariffDescription,
    tariffUnit,
    soc,
    mobileTariffUrl,
    hasDiscount,
  };
};

const getFormData = (state) => {
  const allInOne = state?.home?.allInOne;
  const address = allInOne?.serverData?.address;
  const alias = allInOne?.serverData?.preset;
  const street = allInOne?.street;
  const house = allInOne?.house;
  const flat = allInOne?.flat;
  const flatAlreadyUsed = allInOne?.flatAlreadyUsed;
  const isFlatPartnerConnected = allInOne?.isFlatPartnerConnected;
  const requestData = allInOne?.requestData;
  const region = allInOne?.region;

  return {
    address,
    alias,
    region,
    street,
    house,
    flat,
    flatAlreadyUsed,
    isFlatPartnerConnected,
    requestData,
    isAddressCorrect: !!street?.id && !!house?.isConnected && !!flat,
    services: allInOne?.serverData?.services,
    withoutInternet: allInOne?.activeTabIndex === 0,
    headerRegionId: allInOne?.headerRegionServerData?.globalRegionId,
  };
};

export const makeFormData = (state) => ({
  ...getFormData(state),
  ...getTariffData(state),
});
